<template>
<div>


  <b-card>
    <div class="d-flex justify-content-between align-items-center my-1">
      <h3>
        {{$t('report1')}}
      </h3>


      <b-button
        :title="$t('excel')"
        size="sm"
        variant="success"
        class=""
        @click="downloadExcel1()"
      >
        <feather-icon icon="DownloadIcon" size="15" />
      </b-button>
    </div>
    

    <!-- :busy="loader" -->
    <b-table
      :items="items"
      :fields="fields"
      small
      responsive
      bordered
      striped
      show-empty
    >
      <template #table-busy>
        <div
          class="text-success my-2 d-flex justify-content-center align-items-center"
        >
          <b-spinner />
          <strong class="px-1">Loading...</strong>
        </div>
      </template>
      <template #empty>
        <div class="text-center text-danger my-2">
          <strong>
            {{ $t("objects.no_data") }}
          </strong>
        </div>
      </template>

      <template #thead-top>
        <b-tr class="text-center">
          <b-th variant="secondary" colspan="2">
            
          </b-th>
          <b-th variant="secondary" colspan="4">
            Ишлар номи
          </b-th>
        </b-tr>
      </template>



      <!-- <template #custom-foot>
        <b-tr class="text-center">
          <b-th variant="secondary">
            <span></span>
          </b-th>
          <b-th variant="secondary">
            <span>Жами</span>
          </b-th>
          <b-th variant="secondary">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_category.total.total_count) }}
          </b-th>
          <b-th variant="primary">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_category.total.total_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_category.total.total_fully_paid_count) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_category.total.total_fully_paid_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_category.total.total_partial_paid_count) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_category.total.total_total_partial_unpaid_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_category.total.total_total_partial_paid_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_category.total.total_unpaid_count) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_category.total.total_unpaid_sum) }}
          </b-th>
        </b-tr>
      </template> -->



      <template #cell(numeration)="props">
        {{ props.index + 1 }}
      </template>
      
      <template #cell(total_count)="props">
        {{ $_formatPriceMixin(props.item.total_count) }}
      </template>
      <template #cell(total_sum)="props">
        {{ $_formatPriceMixin(props.item.total_sum) }}
      </template>
   


    </b-table>

  </b-card>








  <b-card>
    <div class="d-flex justify-content-between align-items-center my-1">
      <h3>
        {{$t('report2')}}
      </h3>


      <b-button
        :title="$t('excel')"
        size="sm"
        variant="success"
        class=""
        @click="downloadExcel2()"
      >
        <feather-icon icon="DownloadIcon" size="15" />
      </b-button>
    </div>
    


      <!-- :busy="loader" -->
    <b-table
      :items="items2"
      :fields="fields2"
      small
      responsive
      bordered
      striped
      show-empty
    >
      <template #table-busy>
        <div
          class="text-success my-2 d-flex justify-content-center align-items-center"
        >
          <b-spinner />
          <strong class="px-1">Loading...</strong>
        </div>
      </template>
      <template #empty>
        <div class="text-center text-danger my-2">
          <strong>
            {{ $t("objects.no_data") }}
          </strong>
        </div>
      </template>

      <template #thead-top>
        <b-tr class="text-center">
          <b-th variant="secondary" colspan="2">
            
          </b-th>
          <b-th variant="secondary" colspan="5">
            Ишлар номи
          </b-th>
        </b-tr>
      </template>


<!-- 
      <template #custom-foot>
        <b-tr class="text-center">
          <b-th variant="secondary">
            <span></span>
          </b-th>
          <b-th variant="secondary">
            <span>Жами</span>
          </b-th>
          <b-th variant="secondary">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_type.total.total_count) }}
          </b-th>
          <b-th variant="primary">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_type.total.total_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_type.total.total_fully_paid_count) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_type.total.total_fully_paid_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_type.total.total_partial_paid_count) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_type.total.total_total_partial_unpaid_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_type.total.total_total_partial_paid_sum) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_type.total.total_unpaid_count) }}
          </b-th>
          <b-th variant="danger">
            {{ $_formatPriceMixin(report_requirement_for_brigade_by_work_type.total.total_unpaid_sum) }}
          </b-th>
        </b-tr>
      </template>
 -->


      <template #cell(numeration)="props">
        {{ props.index + 1 }}
      </template>
      
      <template #cell(total_count)="props">
        {{ $_formatPriceMixin(props.item.total_count) }}
      </template>
      <template #cell(total_sum)="props">
        {{ $_formatPriceMixin(props.item.total_sum) }}
      </template>
    </b-table>



  </b-card>





</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { BCard, BSpinner, BTr, BTh, BTable, BButton } from "bootstrap-vue";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import moment from 'moment'

export default {
  components: {
    BCard,
    BTable,
    BSpinner,
    BTr,
    BTh,
    BButton,
  },
  mixins: [priceFormatMixin],

  data() {
    return {
      loader: true,
      items: [],
      items2: [],


      fields: [
        {
          key: "numeration",
          label: "№",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "object",
          label: "Объект номи",
        },
        {
          key: "work_type_category",
          label: "Иш категорияси",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "unit",
          label: "ўлчов бирлиги",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "count",
          label: "сони",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sum",
          label: "суммаси",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      fields2: [
        {
          key: "numeration",
          label: "№",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "object",
          label: "Объект номи",
        },
        {
          key: "work_type_category",
          label: "Иш категорияси",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "work_type",
          label: "ишлар номи",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "unit",
          label: "ўлчов бирлиги",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "count",
          label: "сони",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sum",
          label: "суммаси",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
    };
  },

  computed: {
    ...mapState("application", ["report_requirement_for_brigade_by_work_category"]),
    ...mapState("application", ["report_requirement_for_brigade_by_work_type"]),


   
  },

  async mounted() {

    await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_CATEGORY()
    await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_TYPE()

    this.report_requirement_for_brigade_by_work_category.forEach((elem, index) => {
      if(elem.items.length != 0){
        elem.items.forEach((elem2) => {
          this.items.push({...elem2, object: elem.object})
        })
      } 
    })

    this.report_requirement_for_brigade_by_work_type.forEach((elem, index) => {
      if(elem.items.length != 0){
        elem.items.forEach((elem2) => {
          this.items2.push({...elem2, object: elem.object})
        })
      } 
    })
    

  },

  methods: {
    ...mapActions("application", ["FETCH_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_TYPE", "FETCH_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_CATEGORY"]),

    



    async downloadExcel1() {
      await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_CATEGORY({blob: true, excel: true}).then((res) => {

        const url = window.URL.createObjectURL(
          new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
          })
        );
        const date = new Date();
        const fullDate = moment(date).format("DD-MM-YYYY");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fullDate);
        document.body.appendChild(link);
        link.click();

      });
    },



    async downloadExcel2() {
      await this.FETCH_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_TYPE({blob: true, excel: true}).then((res) => {

        const url = window.URL.createObjectURL(
          new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
          })
        );
        const date = new Date();
        const fullDate = moment(date).format("DD-MM-YYYY");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fullDate);
        document.body.appendChild(link);
        link.click();

      });
    },









  },
};
</script>

<style>
table,
th,
th {
  border: 1px solid #ccc !important;
}
.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}
</style>
